import {useEffect, useState} from "react";
import {AdminUser} from "@/lib/auth";

export default function useCurrentUser() {

    const [error, setError] = useState<Error | null>(null);
    const [user, setUser] = useState<AdminUser|null>(null);
    const [loading, setLoading] = useState(true);

    async function fetchCurrentUser() {
        // `loading` already starts true and we only fetch once (when there's no
        // user yet), so there's no synchronous setState before the first await.
        try {

            const response = await fetch('/api/admin/me');

            if (!response.ok) {
                setError(new Error('Failed to fetch current user'));
                return;
            }
            setUser(await response.json());
        }
        catch (error) {
            setError(error as Error);
            return;
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!user) {
            // Async fetch; all setState happens after the awaited request.
            // eslint-disable-next-line react-hooks/set-state-in-effect
            void fetchCurrentUser();
        }
    }, [user])

    return {user, error, loading};
}